import { ThemeContext } from '@/theme/ThemeProvider';
import { useWindowDimensions } from '@app/hooks';
import { CButton, CInput } from '@components/Common';
import { IconSearch, IconX } from '@tabler/icons-react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HeaderSearchList from './HeaderSearchList';
import {
  HeaderSearchSection,
  Input,
  InputWrapper,
  IconWrapper,
} from './styles';

const HeaderSearch = () => {
  const { theme, isDarkMode } = useContext(ThemeContext);
  const { width } = useWindowDimensions();
  const [hidden, setHidden] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLInputElement>(null);
  const [text, setText] = useState('');
  const [focused, setFocused] = useState(false);
  const { t } = useTranslation();
  const handleChange = (event) => {
    setText(event.target.value);
  };
  const clearInput = () => {
    setText('');
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  const handleOutsideClick = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setFocused(false);
    }
  };
  useEffect(() => {
    if (width < 900) {
      setHidden(false);
    } else if (width < 1200) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  }, [width]);
  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <HeaderSearchSection ref={containerRef}>
      <form>
        {hidden ? (
          <CButton
            icon={<IconSearch size={14} color={theme.COLORS.textw} />}
            onClick={() => {
              setHidden(false);
            }}
            style={{
              background: 'transparent',
              width: 25,
              height: 25,
              borderRadius: 50,
            }}
          />
        ) : (
          <InputWrapper $isDarkMode={isDarkMode}>
            <IconWrapper>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="left-icon"
              >
                <path
                  d="M11.5 11.5L16.5 16.5M7.33333 13.1667C4.11167 13.1667 1.5 10.555 1.5 7.33333C1.5 4.11167 4.11167 1.5 7.33333 1.5C10.555 1.5 13.1667 4.11167 13.1667 7.33333C13.1667 10.555 10.555 13.1667 7.33333 13.1667Z"
                  stroke={theme.COLORS.textw}
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </IconWrapper>

            <Input
              placeholder={t('search')}
              ref={inputRef}
              value={text}
              type={'text'}
              onChange={handleChange}
              onFocus={() => setFocused(true)}
            />
            {/* <div className="left-icon">
              <IconSearch size={14} color={'#BDBDBD'} />
            </div> */}
            {text?.length ? (
              <div className="right-icon" onClick={clearInput}>
                <IconX size={12} />
              </div>
            ) : null}
          </InputWrapper>
        )}
      </form>
      {focused ? <HeaderSearchList text={text} /> : null}
    </HeaderSearchSection>
  );
};

export default React.memo(HeaderSearch);
